var map = {
	"./274/sony-dark.svg": 71666,
	"./274/sony.svg": 30657,
	"./adjuggernaut/logo_dark.png": 76784,
	"./adjuggernaut/logo_light.png": 73938,
	"./adrev/logo_dark.png": 48271,
	"./adrev/logo_light.png": 16063,
	"./altus/logo_dark.png": 45552,
	"./altus/logo_light.png": 43634,
	"./amazonIcon.png": 30097,
	"./cartagent/logo_dark.png": 30368,
	"./cartagent/logo_light.png": 49282,
	"./citiesms/logo_dark.png": 33626,
	"./citiesms/logo_light.png": 91156,
	"./defero/logo_dark.png": 34192,
	"./defero/logo_light.png": 66034,
	"./dspIcon.png": 84098,
	"./googleIcon.png": 84828,
	"./hawkemedia/logo_dark.png": 99107,
	"./hawkemedia/logo_light.png": 81115,
	"./limitless/Limitless-Amazon-AdTech-Platform-Logo-Wide-Bright-Green-900x200-20210209.png": 75112,
	"./metaIcon.png": 5762,
	"./microsoftIcon.png": 91375,
	"./tiktokIcon.png": 20227,
	"./walmartIcon.png": 21783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56960;